import React, { useRef, useEffect } from "react";
import "../../styles/main.scss";

const BPDragAndDrop = ({ ...props }) => {
  const dropRef = useRef(null);

  useEffect(() => {
    const handleDrag = (e) => {
      e.preventDefault();
      e.stopPropagation();
      props.setIsDragging(true);
    };
  
    const handleDragIn = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
        props.setIsDragging(true);
      }
    };
  
    const handleDragOut = (e) => {
      e.preventDefault();
      e.stopPropagation();
      props.setIsDragging(false);
    };
  
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      props.setIsDragging(false);
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        props.handleDropEvent(e.dataTransfer.files);
        e.dataTransfer.clearData();
      }
    };
    
    const div = dropRef.current as any;
    div.addEventListener("dragenter", handleDragIn);
    div.addEventListener("dragleave", handleDragOut);
    div.addEventListener("dragover", handleDrag);
    div.addEventListener("drop", handleDrop);
    
    return () => {
      div.removeEventListener("dragenter", handleDragIn);
      div.removeEventListener("dragleave", handleDragOut);
      div.removeEventListener("dragover", handleDrag);
      div.removeEventListener("drop", handleDrop);
    };
  }, [props]);

  return (
    <div ref={dropRef} className="full-height" onClick={props.onClick}>
      {props.children}
    </div>
  );
};

export default BPDragAndDrop;